import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  box: {
    ...dFlex(),
    gap: 4,
  },
  loader: {
    height: 24,
    width: 150,
  },
  tokensBox: {
    paddingLeft: 4,
    position: 'relative',
  },
  chainLabel: {
    ...dFlex(),
    padding: 1,
    borderRadius: theme.borderRadius.xxl,
    background: theme.primary.p2,
    position: 'absolute',
    right: -4,
    top: -2,
    zIndex: 10,

    img: {
      width: 12,
      height: 12,
      borderRadius: '50%',
    },
  },
  symbol: {
    ...dFlex(),
    gap: 4,
  },
  tokenCircle: {
    backgroundColor: theme.background.b1,
    borderRadius: '50%',
    height: 24,
    opacity: 0.4,
    width: 24,
  },
  chainCircle: {
    backgroundColor: theme.background.b1,
    borderRadius: '50%',
    bottom: 0,
    height: 24,
    opacity: 0.6,
    position: 'absolute',
    right: -4,
    width: 24,
  },
}));

export default useStyles;
